export var WalletStateEnum = /*#__PURE__*/function (WalletStateEnum) {
  WalletStateEnum["Detected"] = "detected";
  WalletStateEnum["NotDetected"] = "not-detected";
  WalletStateEnum["Loadable"] = "loadable";
  return WalletStateEnum;
}({});
export var LoginStateEnum = /*#__PURE__*/function (LoginStateEnum) {
  LoginStateEnum["INITIAL"] = "INITIAL";
  LoginStateEnum["LOCK"] = "LOCK";
  LoginStateEnum["CONNECTING"] = "CONNECTING";
  LoginStateEnum["CONNECTED"] = "CONNECTED";
  LoginStateEnum["DISCONNECTING"] = "DISCONNECTING";
  return LoginStateEnum;
}({});

/**
 * getSignature
 */

export var WalletTypeEnum = /*#__PURE__*/function (WalletTypeEnum) {
  WalletTypeEnum["unknown"] = "Unknown";
  WalletTypeEnum["elf"] = "NightElf";
  WalletTypeEnum["aa"] = "PortkeyAA";
  WalletTypeEnum["discover"] = "PortkeyDiscover";
  return WalletTypeEnum;
}({});
export var SignInDesignEnum = /*#__PURE__*/function (SignInDesignEnum) {
  SignInDesignEnum["SocialDesign"] = "SocialDesign";
  SignInDesignEnum["CryptoDesign"] = "CryptoDesign";
  SignInDesignEnum["Web2Design"] = "Web2Design";
  return SignInDesignEnum;
}({});
export var NetworkEnum = /*#__PURE__*/function (NetworkEnum) {
  NetworkEnum["MAINNET"] = "MAINNET";
  NetworkEnum["TESTNET"] = "TESTNET";
  return NetworkEnum;
}({});